import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';

export type IconName =
  | 'filter'
  | 'heart'
  | 'duplicate'
  | 'trash'
  | 'edit'
  | 'standard-truck'
  | 'express-truck'
  | 'home'
  | 'cart'
  | 'carret-right'
  | 'carret-left'
  | 'arrow-right'
  | 'arrow-left'
  | 'dropdown-arrow-down'
  | 'dropdown-arrow-up'
  | 'dots-vertical'
  | 'secure-payment'
  | 'close'
  | 'checkmark'
  | 'info'
  | 'warning'
  | 'error'
  | 'discount'
  | 'discussion'
  | 'voucher'
  | 'check-circle'
  | 'visibility_off'
  | 'filters'
  | 'eye'
  | 'eye-off'
  | 'heart'
  | 'heart-outline'
  | 'plus'
  | 'search'
  | 'turn-left'
  | 'clock'
  | 'draft'
  | 'library'
  | 'settings'
  | 'menu'
  | 'help'
  | 'language'
  | 'phone'
  | 'user'
  | 'image-special'
  | 'products'
  | 'thumbnail'
  | 'undo'
  | 'reduce'
  | 'retry'
  | 'history'
  | 'trending'
  | 'chat'
  | 'facebook'
  | 'instagram'
  | 'email'
  | 'link'
  | 'timer'
  | 'ruler'
  | 'info-outline'
  | 'caret-up'
  | 'caret-down'
  | 'info-outline'
  | 'parcel-delivered'
  | 'document'
  | 'pencil'
  | 'danger'
  | 'warning'
  | 'discount-badge';

export type IconSize = 'x-small' | 'small' | 'medium' | 'large' | 'x-large';

interface IconElement extends HTMLElement {
  icon: `${IconName}`;
  size: IconSize;
  tooltip?: string;
}

const OpIcon = createWrapper<IconElement>('op-icon');

export default OpIcon;
